<template>
  <div id="CallCell">
    <button id="cellButton" :disabled="disabled || clicked" v-on:click="callCard()">{{cardView}}</button>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "CallCell",
  props: {
    cardName: {
      type: String,
      required: true
    },
    cardView: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      clicked: false
    };
  },
  computed: {
    ...mapGetters({
      callSection: "call/callSection",
      isMyTurn: "game/isMyTurn"
    })
  },
  methods: {
    callCard() {
      if (
        !this.isMyTurn ||
        (this.callSection != "card" && this.cardName != "pass")
      ) {
        return;
      }
      this.clicked = true;
      let payload = {
        card: this.cardName
      }
      this.$store.dispatch("call/callCard", payload)
      .then(() => {
        this.clicked = false;
      });
    }
  }
};
</script>
<style scoped>
#cellButton {
  background-color: black;
  border: solid 4px white;
  color: white;
  border-radius: 10px;
  padding: 12px 25px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 20px;
  margin: 10px;
}
#cellButton:hover:enabled {
  background-color: white;
  border: solid 4px black;
  color: black;
}
#cellButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
@media all and (max-height: 750px), (max-width: 870px){
  #cellButton {
  border: solid 3px white;
  padding: 12px 15px;
  font-size: 18px;
  margin: 5px;
  }
}
@media all and (max-height: 500px) {
  #cellButton {
    border: solid 2px white;
    padding: 8px 10px;
    font-size: 12px;
    margin: 3px;
  }
}
</style>
